import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class AuthStorageService {
  private readonly SESSION_KEY = 'Asset Allocation Calculator';
  private readonly SESSION_KEY_DARK_MODE = 'darkMode';
  private readonly SESSION_KEY_LANG = 'lang';
    constructor(@Inject(PLATFORM_ID) private platformId: object) {}
  save(token: string): void {
    localStorage.setItem(this.SESSION_KEY, token);
  }

  getToken(): string {
      if (isPlatformBrowser(this.platformId)) {
    return localStorage.getItem(this.SESSION_KEY) ?? '';
      } else{
        return ''
      }
  }

  clear(): void {
    localStorage.removeItem(this.SESSION_KEY);
     localStorage.removeItem(this.SESSION_KEY_DARK_MODE);
      localStorage.removeItem(this.SESSION_KEY_LANG);
  }
}